import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxGlideModule } from 'ngx-glide';
import { ProgressBarModule } from 'src/app/common/progress-bar/progress-bar.module';
import { DialogService } from 'src/app/shared/components/dialog/service/dialog.service';
import { CloseBtnModule } from 'src/app/common/close-btn/close-btn.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ICampaign, IUser } from 'src/app/shared/models';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BannerSipDetailCardComponent } from "../banner-sip-detail-card/banner-sip-detail-card.component";
import { BannerMultisipDetailCardComponent } from "../banner-multisip-detail-card/banner-multisip-detail-card.component";
import { SignupService } from 'src/app/shared/services/signup/signup.service';

@Component({
  selector: 'app-home-v2-banner',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    NgxGlideModule,
    ProgressBarModule,
    CloseBtnModule,
    SharedModule,
    BannerSipDetailCardComponent,
    BannerMultisipDetailCardComponent
],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './home-v2-banner.component.html',
  styleUrls: ['./home-v2-banner.component.scss']
})
export class HomeV2BannerComponent {
  constructor(
    public util: UtilService,
    private dialogService: DialogService,
    private events: EventsService,
    private vars: VariablesService,
    private router: Router,
    private signupService: SignupService,
  ) {}

  @Input() type = 'default';
  @Input() campaign: ICampaign | any = {};
  @Input() campaignCountData: any = {};
  @Input() sipSubsCount = 0;
  @Input() activeSipSubscribed;
  @Output() onSipResumeEmit = new EventEmitter();
  @Input() isCountsLoading = false;

  @Input() isLoading = false;

  dialogDataUrl = '';
  @ViewChild('dialogVideoRef') dialogVideoRef;
  @Input() info = {
    title: 'Become a changemaker!',
    shortdesc: '🫰Start with your first contribution',
    countData: [
      { id: 1, count: '12.9K', isHeart: false, desc: 'Lives saved by Ketto' },
      { id: 2, count: '1.2M', isHeart: false, desc: 'Contributors' },
      { id: 3, count: '15.9K',isHeart: false, desc: 'Trusted Campaign' },
    ],
    topSliderContent: [
      { id: 1, pause: true, url: 'https://ketto-media-prod.s3.ap-southeast-1.amazonaws.com/3/videos/Thanks+to+your+support-+my+child+was+able+to+survive+premature+birth..mp4' },
      { id: 2, pause: true, url: 'https://ketto-media-prod.s3.ap-southeast-1.amazonaws.com/3/videos/Ketto+App+Video+01.mp4' },
      { id: 3, pause: true, url: 'https://ketto-media-prod.s3.ap-southeast-1.amazonaws.com/3/videos/Product+App+Video+2.mp4' },
    ],
    btnTitle: 'Make a Change'
  }
  isMobile;
  selectedVideo;

  @Input() configSipPosition;

  ngOnInit() {
    this.isMobile = this.util.isMobile();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['type'] && !changes['type'].isFirstChange()) {
      this.setContent();
    }
  }

  onViewAllSip() {
    const url = environment.sipretention_domain;
    window.location.href = url+ '/sipselect';
  }

  setContent() {
    // if (this.campaign?.end_date && (new Date(this.campaign?.end_date).getTime() - new Date().getTime() <= 0)) {
    //   this.type = 'download_app';
    // }
    this.setTitleAndDownloadBtnTitle(this.type);
    this.info.shortdesc = this.type === 'update' ? '🌍 World is grateful for your contributions ' :'🫰Tap into the world of regular contributions';
    if (this.type !== 'default') {
      this.info.countData = [
        { id: 1, count: this.campaignCountData?.myDonations ? this.campaignCountData?.myDonations: '1', isHeart: false, desc: 'My contributions' },
        { id: 2, count: this.campaignCountData?.livesImpacted ? this.campaignCountData?.livesImpacted  : '2', isHeart: true, desc: 'Lives impacted' },
        { id: 3, count: this.campaignCountData?.doGoodDays && this.campaignCountData.doGoodDays !== 0 ? this.campaignCountData?.doGoodDays : '0', isHeart: false, desc: 'Do good days' },
      ];
      this.info.countData = this.info.countData.map(val => {
        val.count = `${(+val.count <=9 ? '0' : '')}${val.count}`;
        return val;
      } );
    }
  }

  setTitleAndDownloadBtnTitle(choice) {
    const switchObj = {
      'default': {downloadBtnTitle: 'Make a change', title: 'Become a changemaker!'},
      'donate_again': {downloadBtnTitle: 'Make More Difference', title: 'Contribute again!'},
      'update': { downloadBtnTitle: 'View My Impact', title: 'See contribution updates!' },
      'updatesippitch': { downloadBtnTitle: 'View My Impact', title: 'See contribution updates!' },
      'download_app': { downloadBtnTitle: 'Download the App', title: 'Download the app' }
    }
    this.info.btnTitle = switchObj[choice || 'default'].downloadBtnTitle;
    this.info.title = switchObj[this.type||'default'].title;
  }

  openDialog(item) {
    this.selectedVideo = item;
    this.dialogDataUrl = item.url;
    let height = '';
    if (item.id === 1 && this.isMobile) {
      height = '295px';
    } else if (item.id && !this.isMobile) {
      height = '390px';
    } else if (item.id !== 1 && this.isMobile) {
      height = '415px';
    } else if (item.id !== 1 && !this.isMobile) {
      height = '390px'
    }
    const dialogVideoRef = this.dialogService.openDialogViaTemplate(this.dialogVideoRef, {
      width: '600px',
      height,
      panelClass: 'video-dialog-popup'
    });
    dialogVideoRef.afterClosed().subscribe(val => {
      const videoEl = this.dialogVideoRef.elementRef.nativeElement.querySelector('video');
      if (!videoEl.paused) {
        videoEl.pause();
      }
    });
  }

  onBottmBtnClicked() {
    if (this.type === 'donate_again') {
      // this.router.navigate(['/crowdfunding/fundraisers', this.campaign.campaignUrl])
      window.location.href = this.campaign.campaignUrl;
    } else if (this.type === 'default') {
      this.router.navigate(['/crowdfunding/fundraisers']);
    } else if (this.type === 'download_app') {
      const redLink = this.util.isIOSDevice() || this.util.isAppleDevice() ? this.vars.appLink.iOS : this.vars.appLink.android;
      this.util.nativeNavigation(redLink, true)
    } else if (this.type == 'update') {
      window.location.href = environment.sipretention_domain + '/updates';
    } else if (this.type == 'non_logged_in') {
      this.signupService.startFR();
    }

    this.events.sendSystemEvent({
      eventName: 'click_on_banner',
      pageName: this.vars.pageName,
      info_1: 'top_fold_'+ this.type
    }).subscribe(_=> _);
  }

  onViewMyImpactClicked() {
    let height = this.isMobile? '415px': '390px';
    this.dialogDataUrl = this.info.topSliderContent[1].url;
    this.selectedVideo = this.info.topSliderContent[1];
    const dialogVideoRef = this.dialogService.openDialogViaTemplate(this.dialogVideoRef, {
      width: '600px',
      height,
      panelClass: 'video-dialog-popup'
    });
    dialogVideoRef.afterClosed().subscribe(val => {
      const videoEl = this.dialogVideoRef.elementRef.nativeElement.querySelector('video');
      if (!videoEl.paused) {
        videoEl.pause();
      }
    });
  }
}